import * as React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import FormField from '../../components/FormField/FormField';
import Appear from '../../components/Appear/Appear';
import withContainer from '../../containers/WithContainer';
import { withRouter } from 'react-router-dom';

class NameEmail extends React.Component<any> {
  onNext = () => {
    this.props.appContainer.updateNameEmail(
      this.props.appContainer.state.step1,
      this.getCurrStep(),
      localStorage.getItem('queryString')
        ? localStorage.getItem('queryString')
        : '  '
    );
  };

  getCurrStep = () => {
    let step = parseInt(this.props.match.path.split('-')[1]);
    return step;
  };

  componentDidUpdate() {
    console.log(this.props.appContainer.state.provider.isActive)
  }

  render() {

    return (
      <>
        {!this.props.appContainer.state.provider.isActive &&
          <WizardCard
            isPrevHidden
            delay={2.4}
            duration={0.5}
            subTitle="Only your first name is shown to the customer"
            isDisabled={
              !this.props.appContainer.state.step1.first_name ||
              !this.props.appContainer.state.step1.last_name ||
              !this.props.appContainer.state.emailIsValid
            }
            onNext={this.onNext}
            title="What are your details?"
          >
            <div className="column is-paddingless">
              <FormField label="First Name" htmlFor="firstName" required>
                <input
                  id="firstName"
                  name="first_name"
                  onChange={event => {
                    this.props.appContainer.onStep1FieldChange(event);
                  }}
                  value={this.props.appContainer.state.step1.first_name || ''}
                  type="text"
                  className="input"
                  placeholder=""
                />
              </FormField>
            </div>

            <div className="column is-paddingless has-margin-top-20">
              <FormField label="Last Name" htmlFor="lastName" required>
                <input
                  id="lastName"
                  name="last_name"
                  onChange={event => {
                    this.props.appContainer.onStep1FieldChange(event);
                  }}
                  value={this.props.appContainer.state.step1.last_name || ''}
                  type="text"
                  className="input"
                  placeholder=""
                />
              </FormField>
            </div>

            <div className="column is-paddingless has-margin-top-20">
              <FormField label="Email" htmlFor="email" required>
                <input
                  id="email"
                  name="email"
                  onChange={event => {
                    this.props.appContainer.onStep1FieldChange(event);
                  }}
                  value={this.props.appContainer.state.step1.email || ''}
                  type="email"
                  className="input"
                  placeholder="e.g. email@example.com"
                />
              </FormField>
            </div>
          </WizardCard>
        }
        {this.props.appContainer.state.provider.isActive &&
          <div style={{ textAlign: 'center' }}>
            You are already on Flayr.
          Click <a href="https://mua.flayr.io" target="_blank">here</a> to access your dashboard.
        </div>
        }

      </>
    );
  }
}

export default withRouter(withContainer(NameEmail));
